import { CMDUltraRouletteMultipier } from "./CMDUltraRouletteMultipier"
import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDScUltraRouletteMultipier implements ICommand
{

	public HostID : number = 0;
	public GameID : number = 0;
	public MultiList : Array<CMDUltraRouletteMultipier>;

	public constructor()
	{
		this.MultiList = new Array<CMDUltraRouletteMultipier>();
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.HostID = ba.readUint16();
		this.GameID = ba.readUint53();
		let MultiListSize:number = ba.readUint53();
		while (MultiListSize-- > 0)
		{
			let MultiListChild:CMDUltraRouletteMultipier = new CMDUltraRouletteMultipier();
			MultiListChild.fromBytes(ba);
			this.MultiList.push(MultiListChild);
		}
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint16(this.HostID);
		ba.writeUint53(this.GameID);
		ba.writeUint53(this.MultiList.length);
		for (const MultiListChild of this.MultiList)
		{
			let tempBuf = MultiListChild.toBytes();
			ba.appendBuf(tempBuf.toBuffer());
		}

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDScUltraRouletteMultipier();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'HostID(W)='+this.HostID+' ';
		str += 'GameID(Q)='+this.GameID+' ';
		str += 'MultiList_size(Q)='+this.MultiList.length + ' ';
		str += 'MultiList(CMDUltraRouletteMultipier)=[';
		for (let MultiListChild in this.MultiList)
		{
			if (<number><unknown>MultiListChild > 0) str += ', ';
			str += this.MultiList[MultiListChild].toString();
		}
		str += '] ';
		return str;
	}

	public getCmdID() : number
	{
		return 30051;
	}

	public getCmdName() : string
	{
		return 'ScUltraRouletteMultipier';
	}

}
